export const curtainVariants = {
  hidden: {
    x: "-100%",
    transition: {
      when: "afterChildren",
      staggerChildren: 0.1,
      duration: 0.1
    }
  },
  visible: {
    x: 0,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
      duration: 0.1
    }
  }
};
export const curtainVariantsAr = {
  hidden: {
    x: "100%",
    transition: {
      when: "afterChildren",
      staggerChildren: 0.1,
      duration: 0.1
    }
  },
  visible: {
    x: 0,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
      duration: 0.1
    }
  }
};

export const mainMenuVariants = {
  hidden: {
    x: "-40px",
    opacity: 0,
    transition: {
      when: "afterChildren",
      staggerChildren: 0.1,
      duration: 0.2
    }
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
      duration: 0.2
    }
  }
};

export const mainMenuVariantsAr = {
  hidden: {
    x: "40px",
    opacity: 0,
    transition: {
      when: "afterChildren",
      staggerChildren: 0.1,
      duration: 0.2
    }
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
      duration: 0.2
    }
  }
};

export const subMenuVariants = {
  hidden: {
    height: 0,
    overflow: "hidden",
    transition: {
      when: "afterChildren",
      staggerChildren: 0.1,
      duration: 0.1
    }
  },
  visible: {
    height: "auto",
    overflow: "hidden",
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
      duration: 0.1
    }
  }
};

export const subMenuItemVariants = {
  hidden: {
    x: -40,
    opacity: 0
  },
  visible: {
    x: 0,
    opacity: 1
  }
};

export const subMenuItemVariantsAr = {
  hidden: {
    x: 40,
    opacity: 0
  },
  visible: {
    x: 0,
    opacity: 1
  }
};
